import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Breadcrumb from '../components/Breadcrumb';
import noImage from "../Image/no-image.jpg";
import Spinner from "react-bootstrap/Spinner";
import { BASE_URL } from "../Utils/base_url";
import Pagination from '@material-ui/lab/Pagination';
import Slider from "react-slick";
import { AfficheRestaurantHome } from '../Api/RestaurantHomeApi';

import '../Css/restaurant.css';

const Restaurant = () => {

    const [loadRestaurant, setLoadRestaurant] = useState(false);
    const [dataRestaurant, setDataRestaurant] = useState([]);
    const [dataVille, setDataVille] = useState([]);

    const [restaurantPaginate, setRestaurantPaginate] = useState([]);
    const [showPaginate, setShowPaginate] = useState(true);
    const [totalPage, setTotalPage] = useState();
    const [page, setPage] = useState(1);

    const [dataResto, setDataResto] = useState([]);
    const [loadValue, setLoadValue] = useState(false);
    const [dataFilter, setDatafilter] = useState([]);

    const [filterActif, setFilterActif] = useState("");


    const location = useLocation();
    const navigate = useNavigate();



    useEffect(() => {
        AfficheRestaurantData();
    }, []);

    useEffect(() => {
        if (dataRestaurant.length <= 12) {
            setShowPaginate(false);
        } else {
            setShowPaginate(true);
        }
    }, [dataRestaurant.length])


    const AfficheRestaurantData = (value = null) => {
        let dataPage = value === null ? page : value;
        setLoadRestaurant(true);

        AfficheRestaurantHome(dataPage).then(function (response) {
            console.log('Liste Restaurant =>', response.data.donner);
            setDataResto(response.data.restaurant);
            setDataRestaurant(response.data.restaurant);
            setRestaurantPaginate(response.data.donner);
            setTotalPage(response.data.totalPage);
            const villeData = [];
            response.data.donner.forEach((element, index) => {
                let existeVille = villeData.find((el) => el.ville === element.ville);
                if (existeVille) {
                    return console.log("Ville existe ...");
                } else {
                    return villeData.push({ id: index + 1, ville: element.ville })
                }

            });

            setDataVille(villeData);
        }).catch(function (error) {
            console.log(error);
        }).finally(function () {
            setLoadRestaurant(false);
        });


    }


    const handlePage = (event, value) => {
        setPage(value);
        AfficheRestaurantData(value);
    }


    var settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        pauseOnHover: true,
        speed: 2000,
        autoplaySpeed: 8000,
        swipeToSlide: true,
        slidesToShow: dataVille.length < 8 ? dataVille.length : 8,
        slidesToScroll: dataVille.length < 8 ? dataVille.length : 8,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: dataVille.length < 6 ? dataVille.length : 6,
                    slidesToScroll: dataVille.length < 6 ? dataVille.length : 6,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: dataVille.length < 4 ? dataVille.length : 4,
                    slidesToScroll: dataVille.length < 4 ? dataVille.length : 4,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: dataVille.length < 2 ? dataVille.length : 2,
                    slidesToScroll: dataVille.length < 2 ? dataVille.length : 2
                }
            },
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: dataVille.length < 2 ? dataVille.length : 2,
                    slidesToScroll: dataVille.length < 2 ? dataVille.length : 2
                }
            }
        ]
    };




    const viewPromotion = (promo) => {
        const existePromo50 = promo.find((el) => el.libelle === "Promotion de -50%");
        const existePromo40 = promo.find((el) => el.libelle === "Promotion de -40%");
        const existePromo30 = promo.find((el) => el.libelle === "Promotion de -30%");
        const existePromo20 = promo.find((el) => el.libelle === "Promotion de -20%");
        const existePromo10 = promo.find((el) => el.libelle === "Promotion de -10%");
        const existePromoSpecial = promo.find((el) => el.libelle === "Promotion : Menu spécial");

        if (existePromo50) {
            return (<label>-50%</label>);
        } else if (existePromo40) {
            return (<label>-40%</label>);
        } else if (existePromo30) {
            return (<label>-30%</label>);
        } else if (existePromo20) {
            return (<label>-20%</label>);
        } else if (existePromo10) {
            return (<label>-10%</label>);
        } else if (existePromoSpecial) {
            return (<label>Spécial</label>);

        } else {
            return (<p>Pas de promotion ...</p>);
        }

    }

    const safeParseFloat = (str) => {
        const value = Number.parseFloat(str);

        return Number.isNaN(value) ? 0 : value;
    };


    const viewRestaurant = (item, index) => {


        const notes = safeParseFloat(
            item.notes.reduce(
                (prevNote, currentNote) => prevNote + parseInt(currentNote.note),
                0
            ) / item.notes.length
        );




        return (
            <div
                className='col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 d-flex justify-content-center' key={index}>

                <div className='items'>
                    <div className='box shadow'>
                        <div className='images'>
                            <div className='img'>
                                <img
                                    src={
                                        item.photos.length === 0
                                            ? noImage
                                            : BASE_URL + item.photos[0]?.urlPhoto
                                    }
                                    alt="logo restaurant"
                                />
                            </div>
                            <div className='category'>
                                <span>{item.typeCuisines[0]?.libelle}</span>
                            </div>
                        </div>
                        <div className='legend'>
                            <h3 className='title text-center'>{item.nomRestaurant}</h3>
                            {/* <h3 className='title'>{val.title.slice(0, 40)}...</h3> */}
                            <div className='sub_footer'>
                                <div>
                                    <i className='fa fa-bookmark'></i>
                                    <label>PM : {item.prixMoyenne[0]?.prix} Ar</label>
                                </div>
                                {item.promotions.length !== 0 ?
                                    <div className="reduction">
                                        <i className='fa fa-bullhorn'></i>
                                        {viewPromotion(item.promotions)}
                                    </div>
                                    : ""}

                            </div>
                            <div className="note_avis">
                                <div> <span className='note'>Note: {notes.toFixed(2)}/20</span></div>
                                <div><span className='avis'>Avis: {item.avis.length}</span></div>
                            </div>
                            <div className='footer_card'>
                                <div className='adresse'>
                                    <i className='fa fa-map-marker'></i>
                                    <label>{item.adresse}</label>
                                </div>

                                <div className='d-flex justify-content-center mt-2'>
                                    <Link to={`/restoPage/${item.id}`} title="page restaurant" className='btn btn_reserver'>Détails</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }



    const handleSearch = (e) => {
        if (e.target.value !== "") {
            setLoadValue(true);
            let dataFilter = dataResto.filter((resto) => resto.nomRestaurant.toLowerCase().includes(e.target.value.toLowerCase()));
            setDatafilter(dataFilter);
        } else {
            setLoadValue(false);
        }
    }

    const handleVille = (ville) => {
        let dataFilter = dataResto.filter((resto) => resto.ville.toLowerCase().includes(ville.toLowerCase()));
        if (dataFilter.length !== 0) {
            setDatafilter(dataFilter);
            setFilterActif(ville);
            setLoadValue(true);
        } else {
            setLoadValue(false);
            setFilterActif("");
        }

        console.log("Les ville filter est =>", dataFilter);
    }


    const handleTous = () => {
        setDatafilter(dataResto);
    }

    console.log("Les ville est =>", dataVille);


    return (
        <div>
            <Helmet>
                <title>Restaurant ~ Liste</title>
                <meta name='description' content='Restaurant liste.' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className="restaurantData">
                <div className='restaurant_image_header'>
                    <div className='img'>
                        <img src={BASE_URL + localStorage.getItem('urlHero')} alt="header restaurant" className="shadow" />
                    </div>
                    <div className='content_header'>
                        <Breadcrumb />
                        <div className='container'>

                            <div className='titre'>
                                <h1 className='text-center'>Chercher votre restaurant</h1>
                            </div>
                            <div className='d-flex justify-content-center'>
                                <div className='form_input'>
                                    <input type="text" onChange={handleSearch} className='form-control' placeholder='Recherche restaurant ...' />
                                    <i className='fa fa-search'></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ville">
                    <div className={'ville_itemAll'} onClick={() => handleTous()}>
                        <i className='fa fa-map-o'></i>
                        <span>Tous</span>
                    </div>
                    <div className='ville_content'>

                        {dataVille.length !== 0 ?
                            <Slider {...settings}>
                                {dataVille.map((item, index) => {
                                    return (<div className={item.ville === filterActif ? 'ville_item actif' : 'ville_item'} key={index} onClick={() => handleVille(item.ville)}>
                                        <i className='fa fa-map-o'></i>
                                        <span>{item.ville}</span>
                                    </div>)
                                })}
                            </Slider>
                            : <p>Pas de ville ...</p>}
                    </div>
                </div>
                <div className='heading_une'>
                    <h2>Restaurants disponible</h2>
                </div>
                <div className="liste_restaurant">
                    <div className="row">

                        {loadRestaurant === true ?
                            <div className="d-flex justify-content-center">
                                <Spinner
                                    animation="border"
                                    className="load"
                                    variant="info"
                                    size="md"
                                />
                            </div> : restaurantPaginate.length === 0 || dataResto.length === 0 ? <p>Pas de restaurant disponible ...</p> :
                                loadValue === true ? dataFilter.length === 0 ? <p>Demande introuvable ...</p> : dataFilter.map((item, index) => {
                                    return viewRestaurant(item, index);
                                }) : restaurantPaginate.map((item, index) => {
                                    return viewRestaurant(item, index);
                                })
                        }

                    </div>
                </div>
                {showPaginate && <div className='d-flex justify-content-center mt-4'>
                    <Pagination
                        shape="rounded"
                        count={Math.ceil(totalPage)}
                        onChange={handlePage}
                    />
                </div>
                }
            </div>
        </div>
    )
}

export default Restaurant;